var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { Inline } from "syf-component-library/ui/spacing";
import Stack from "syf-component-library/ui/spacing/Stack";
import { Body } from "syf-component-library/ui/typography";
import getTranslation from "../../../../../strings/getTranslations";
import AccountsList from "./AccountsList";
import { ChipContainer, RadioChip } from "./subcomponents";
import { useEditProfileContext } from "../../../../../context/editProfileContext";
import triggerProfileAnalytics from "../../../../../helpers/triggerProfileAnalytics";
import { RowInput } from "../../../../subcomponents";
var MultiAccountOptions = function (_a) {
    var multiAccountToggle = _a.multiAccountToggle, isMultiAccountPicked = _a.isMultiAccountPicked, triggerMultiAccountOption = _a.triggerMultiAccountOption;
    var t = getTranslation().t;
    var _b = useEditProfileContext(), selectedAccounts = _b.selectedAccounts, updateSelectedAccounts = _b.updateSelectedAccounts;
    var isSubmitting = useFormContext().formState.isSubmitting;
    var handleOnChange = function (option) {
        var analyticsButton = option ? "yes" : "no";
        triggerProfileAnalytics({
            pageName: "edit",
            messageType: "apply changes to other accounts - ".concat(analyticsButton),
        });
        if (option) {
            triggerMultiAccountOption(true);
        }
        else {
            updateSelectedAccounts([selectedAccounts[0]]);
            triggerMultiAccountOption(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "xlarge" }), _jsx(Body, { children: t("labels.multiaccount") }), _jsx(Stack, { size: "large" }), _jsxs(ChipContainer, __assign({ "data-cy": "chipContainer" }, { children: [_jsx(RadioChip, __assign({ id: "yesChip", name: "chip", value: "chip", disabled: isSubmitting, checked: multiAccountToggle && isMultiAccountPicked, onChange: function () { return handleOnChange(true); }, radioType: "chip", dataType: "all account changes", dataReason: "yes", dataObject: "button", dataAnalytics: "clicktrackingevent" }, { children: t("actions.yes") })), _jsx(Inline, { size: "large" }), _jsx(RadioChip, __assign({ id: "noChip", name: "chip", value: "chip", disabled: isSubmitting, checked: !multiAccountToggle && isMultiAccountPicked, onChange: function () { return handleOnChange(false); }, radioType: "chip", dataType: "all account changes", dataReason: "no", dataObject: "button", dataAnalytics: "clicktrackingevent" }, { children: t("actions.no") }))] })), _jsx(Stack, { size: "medium" }), multiAccountToggle && (_jsxs(RowInput, __assign({ "data-testid": "multiAccountContainer" }, { children: [_jsx(Stack, { size: "small" }), _jsx(AccountsList, {})] })))] }));
};
export default MultiAccountOptions;
